import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  AuthBox,
  Avatar,
  DropdownItem,
  DropdownItemLogout,
  DropdownMenu,
  Footer,
  FooterContainer,
  GoogleButton,
  Header,
  HeaderContainer,
  LanguageSwitch,
  LoginButton,
  Logo,
  LogoIcon,
  LogoutIcon,
  MobileMenuButton,
  Overlay,
  Page,
  Sidebar,
  SidebarItem,
  SidebarItemMain,
  SidebarUserMobile,
  UserMenuWrapper,
  UserName,
  UserTrigger,
} from "./App_Style";
import ToastContainer from "./notification/NotificationBell";
import { type ReactNode, useEffect, useRef, useState } from "react";
import { envConfig } from "./config/env.config";
import { IGoogleLoginRequest } from "./models/auth";
import AuthService from "./services/api/auth.service";
import { parseJwt } from "./common/helper";
import { ITokenPayload } from "./models/user";
import { toast } from "./utils/notify";
import NotificationCenter from "./notification/NotificationBell";
import { connectSignal } from "./services/api/signalr.Service";
import { jwtDecode } from "jwt-decode";
import { useStore } from "./zustand";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { NavMenu, NavItem, NavItemActive } from "./App_Style";
import { ESettingResponse } from "./models/setting";
import SettingService from "./services/api/setting.service";
import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import { changeLanguage, CountryLanguage } from "./i18n/i18n";
import { Trans, useTranslation } from "react-i18next";
import { set } from "react-hook-form";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import VisitService from "./services/api/visit.service";
import BlogFooterService from "./services/api/blogfooter.service";
import { EBlogResponse, IBlogGetPage } from "./models/blog";
// import "quill-table-better/dist/quill-table-better.css";

// const footerSupportLinks = [
//   {
//     label: "Chính sách & Điều khoản sử dụng",
//     href: "https://docme.vn/chinh-sach-dieu-khoan-su-dung",
//   },
//   {
//     label: "Chính sách thanh toán",
//     href: "https://docme.vn/chinh-sach-thanh-toan",
//   },
//   {
//     label: "Chính sách bảo mật",
//     href: "https://docme.vn/chinh-sach-bao-mat",
//   },
//   {
//     label: "Hướng dẫn sử dụng",
//     href: "https://docme.vn/huong-dan-su-dung",
//   },
//   {
//     label: "Thông tin liên hệ",
//     href: "https://docme.vn/thong-tin-lien-he",
//   },
// ];

const DOCME_FOOTER_CSS = `
  .docme-footer {
    position: relative;
    overflow: hidden;
    margin-top: 72px;
    padding-bottom: 46px;
    background:
      radial-gradient(circle at top left, rgba(124, 58, 237, 0.18), transparent 34%),
      radial-gradient(circle at bottom right, rgba(59, 130, 246, 0.16), transparent 32%),
      linear-gradient(180deg, #ffffff 0%, #f7f5ff 100%);
    border-top: 1px solid rgba(124, 58, 237, 0.12);
    color: #19162a;
  }

  .docme-footer::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background-image:
      linear-gradient(rgba(124, 58, 237, 0.055) 1px, transparent 1px),
      linear-gradient(90deg, rgba(124, 58, 237, 0.055) 1px, transparent 1px);
    background-size: 42px 42px;
    mask-image: linear-gradient(
      to bottom,
      transparent,
      #000 18%,
      #000 82%,
      transparent
    );
  }

  .docme-footer-inner {
    position: relative;
    z-index: 1;
    width: min(1180px, calc(100% - 32px));
    margin: 0 auto;
    padding: 54px 0 24px;
  }

  .docme-footer-main {
    display: grid;
    grid-template-columns: 1.15fr 1.25fr 0.9fr;
    gap: 28px;
  }

  .docme-footer-card {
    border: 1px solid rgba(124, 58, 237, 0.12);
    background: rgba(255, 255, 255, 0.76);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border-radius: 24px;
    padding: 26px;
    box-shadow: 0 18px 50px rgba(31, 22, 84, 0.08);
  }

  .docme-footer-logo {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    margin-bottom: 16px;
    text-decoration: none;
    font-size: 36px;
    line-height: 1;
    font-weight: 900;
    letter-spacing: -1.6px;
    background: linear-gradient(135deg, #7c3aed, #2563eb);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  .docme-footer-logo span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 22px;
    margin-left: 3px;
    border-radius: 999px;
    color: #ffffff;
    font-size: 13px;
    letter-spacing: -0.3px;
    background: linear-gradient(135deg, #2563eb, #7c3aed);
  }

  .docme-footer-desc {
    max-width: 390px;
    margin: 0;
    color: #5b5670;
    font-size: 15px;
    line-height: 1.75;
  }

  .docme-footer-badge {
    display: inline-flex;
    align-items: center;
    margin-top: 22px;
    padding: 9px 14px;
    border-radius: 999px;
    color: #5b21b6;
    background: rgba(124, 58, 237, 0.1);
    font-size: 13px;
    font-weight: 700;
  }

  .docme-footer-title {
    margin: 0 0 18px;
    color: #141126;
    font-size: 17px;
    font-weight: 800;
  }

  .docme-footer-contact-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 0;
    color: #3d3854;
    text-decoration: none;
    font-size: 15px;
    line-height: 1.55;
    transition:
      color 0.2s ease,
      transform 0.2s ease;
  }

  .docme-footer-contact-item + .docme-footer-contact-item {
    border-top: 1px solid rgba(124, 58, 237, 0.1);
  }

  .docme-footer-contact-item:hover {
    color: #6d28d9;
    transform: translateX(3px);
  }

  .docme-footer-icon {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 14px;
    color: #6d28d9;
    background: linear-gradient(
      135deg,
      rgba(124, 58, 237, 0.12),
      rgba(37, 99, 235, 0.1)
    );
  }

  .docme-footer-icon svg {
    width: 18px;
    height: 18px;
    stroke-width: 2.1;
  }

  .docme-footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .docme-footer-links li + li {
    margin-top: 10px;
  }

  .docme-footer-links a {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 11px 12px;
    border-radius: 14px;
    color: #3d3854;
    background: rgba(255, 255, 255, 0.58);
    text-decoration: none;
    font-size: 15px;
    font-weight: 650;
    transition: all 0.2s ease;
  }

  .docme-footer-links a::before {
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: linear-gradient(135deg, #7c3aed, #2563eb);
    box-shadow: 0 0 0 4px rgba(124, 58, 237, 0.1);
  }

  .docme-footer-links a:hover {
    color: #5b21b6;
    background: rgba(124, 58, 237, 0.09);
    transform: translateX(4px);
  }

  .docme-footer-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-top: 28px;
    padding-top: 22px;
    border-top: 1px solid rgba(124, 58, 237, 0.14);
    color: #69637d;
    font-size: 14px;
  }

  .docme-footer-bottom p {
    margin: 0;
  }

  .docme-footer-bottom-links {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .docme-footer-bottom-links a {
    color: #5b21b6;
    text-decoration: none;
    font-weight: 700;
  }

  .docme-footer-bottom-links a:hover {
    text-decoration: underline;
  }

  /* =========================
     BOTTOM MARQUEE
  ========================== */

  .docme-bottom-marquee {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;

  width: 100vw;
  height: 46px;
  display: flex;
  align-items: center;
  overflow: hidden;

  background: rgba(30, 20, 60, 0.78);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  border-top: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow: 0 -8px 30px rgba(15, 23, 42, 0.18);
}

.docme-bottom-marquee-track {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: max-content;
  min-width: 200%;
  white-space: nowrap;

  animation: docmeMarquee 25s linear infinite;
  will-change: transform;
}

.docme-bottom-marquee-content {
  width: 50%;
  min-width: 100vw;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 80px;

  padding: 0 40px;
  box-sizing: border-box;

  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.2px;
}

.docme-bottom-marquee-item {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 14px;
}

.docme-bottom-marquee-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  flex-shrink: 0;

  border-radius: 50%;
  background: #c4b5fd;

  box-shadow:
    0 0 0 4px rgba(196, 181, 253, 0.12),
    0 0 14px rgba(196, 181, 253, 0.85);
}

.docme-bottom-marquee:hover .docme-bottom-marquee-track {
  animation-play-state: paused;
}

@keyframes docmeMarquee {
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(-50%, 0, 0);
  }
}

@media (max-width: 640px) {
  .docme-bottom-marquee {
    height: 42px;
  }

  .docme-bottom-marquee-track {
    animation-duration: 18s;
  }

  .docme-bottom-marquee-content {
    min-width: 100vw;
    gap: 50px;
    padding: 0 24px;
    font-size: 13px;
  }
}
`;

type FooterIconType = "location" | "phone" | "mail" | "globe";

function FooterSvgIcon({ type }: { type: FooterIconType }) {
  const icons: Record<FooterIconType, ReactNode> = {
    location: (
      <path d="M12 21s7-4.35 7-11a7 7 0 1 0-14 0c0 6.65 7 11 7 11Zm0-8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
    ),
    phone: (
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.78 19.78 0 0 1 3.11 5.18 2 2 0 0 1 5.1 3h3a2 2 0 0 1 2 1.72c.12.9.33 1.77.63 2.6a2 2 0 0 1-.45 2.11L9 10.7a16 16 0 0 0 4.3 4.3l1.27-1.27a2 2 0 0 1 2.11-.45c.83.3 1.7.51 2.6.63A2 2 0 0 1 22 16.92Z" />
    ),
    mail: (
      <>
        <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" />
        <path d="m22 6-10 7L2 6" />
      </>
    ),
    globe: (
      <>
        <circle cx="12" cy="12" r="10" />
        <path d="M2 12h20" />
        <path d="M12 2a15.3 15.3 0 0 1 0 20" />
        <path d="M12 2a15.3 15.3 0 0 0 0 20" />
      </>
    ),
  };

  return (
    <span className="docme-footer-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        {icons[type]}
      </svg>
    </span>
  );
}

function App() {
  const googleInited = useRef(false);
  const [user, setUser] = useState<ITokenPayload | null>();
  const [showMenu, setShowMenu] = useState(false);
  const setData = useStore((s) => s.setData);
  const navigate = useNavigate();
  const location = useLocation();
  const [setting, setSetting] = useState<ESettingResponse | null>(null);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [footerSupportLinks, setFooterSupportLinks] =
    useState<EBlogResponse[]>();

  // const [checked, setChecked] = useState(false);
  const { t, i18n } = useTranslation();
  const footerSetting = setting as any;
  const footerAddress = t("address");
  const footerHotline = footerSetting?.hotline || "0909326456";
  const footerEmail = footerSetting?.email || "support@mikotech.vn";
  const footerWebsite =
    envConfig.KEY_BASE === "vn" ? "https://docme.vn/" : "https://docme.world/";

  const isActive = (path: string) => location.pathname === path;
  const checked = i18n.language === CountryLanguage.EN;

  useEffect(() => {
    SettingService.getSingle().then((res) => {
      if (res.success) setSetting(res.data);
    });
  }, []);

  useEffect(() => {
    const connect = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        await connectSignal(token); // Kết nối SignalR 1 lần sau khi login
      }
    };

    connect();
  }, [user]);

  useEffect(() => {
    const blockRightClick = (e: any) => {
      e.preventDefault();
    };

    const blockKeys = (e: any) => {
      const key = e.key?.toLowerCase();

      if (
        e.key === "F12" ||
        (e.ctrlKey && key === "u") ||
        (e.ctrlKey && e.shiftKey && key === "i") ||
        (e.ctrlKey && e.shiftKey && key === "j") ||
        (e.ctrlKey && e.shiftKey && key === "c") ||
        (e.ctrlKey && key === "s")
      ) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener("contextmenu", blockRightClick);
    document.addEventListener("keydown", blockKeys);

    return () => {
      document.removeEventListener("contextmenu", blockRightClick);
      document.removeEventListener("keydown", blockKeys);
    };
  }, [user]);

  // useEffect(() => {
  //   if (!setting) return;

  //   const inject = (html: string, target: "body") => {
  //     if (!html) return;

  //     const parser = new DOMParser();
  //     const doc = parser.parseFromString(html, "text/html");

  //     // ===== SCRIPT =====
  //     const scripts = doc.querySelectorAll("script");

  //     scripts.forEach((oldScript) => {
  //       const newScript = document.createElement("script");

  //       Array.from(oldScript.attributes).forEach((attr) => {
  //         newScript.setAttribute(attr.name, attr.value);
  //       });

  //       newScript.text = oldScript.innerHTML;

  //       document.body.appendChild(newScript);
  //     });

  //     // ===== NOSCRIPT =====
  //     const noscriptRegex = /<noscript>([\s\S]*?)<\/noscript>/gi;
  //     const matches = html.match(noscriptRegex);

  //     if (matches) {
  //       matches.forEach((noscriptStr) => {
  //         let content = noscriptStr
  //           .replace(/<noscript>/i, "")
  //           .replace(/<\/noscript>/i, "");

  //         // decode nếu bị encode
  //         const textarea = document.createElement("textarea");
  //         textarea.innerHTML = content;
  //         content = textarea.value;

  //         const newNoscript = document.createElement("noscript");

  //         const temp = document.createElement("div");
  //         temp.innerHTML = content;

  //         Array.from(temp.childNodes).forEach((node) => {
  //           newNoscript.appendChild(node);
  //         });

  //         // ❗ noscript luôn nên nằm ở body
  //         document.body.appendChild(newNoscript);
  //       });
  //     }
  //   };

  //   // inject head
  //   // inject(setting.headJs, "head");

  //   // inject body

  //   inject(setting.bodyNoScriptJs, "body");

  //   inject(setting.bodyScriptJs, "body");
  // }, [setting]);

  useEffect(() => {
    const getFooter = async () => {
      const page: IBlogGetPage = {
        CurrentPage: 1,
        PageSize: 10,
        Language: i18n.language,
        KeySearch: "",
      };

      const res = await BlogFooterService.userGetPage(page);
      if (res.success) {
        setFooterSupportLinks(res.items);
      }
    };

    getFooter();
  }, [i18n.language]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (envConfig.KEY_BASE === "world") {
      const createVisit = async () => {
        const res = await VisitService.getGetCountryCode();
        if (res.success) {
          // user đã chọn language trước đó
          const savedLang = localStorage.getItem("language");

          if (savedLang) {
            changeLanguage(savedLang as CountryLanguage);
            return;
          }

          let lang = res.data;

          const validLanguages = Object.values(CountryLanguage);

          if (
            lang === "Local" ||
            !lang ||
            !validLanguages.includes(lang as CountryLanguage)
          ) {
            lang = CountryLanguage.EN;
          }

          changeLanguage(lang as CountryLanguage);
          localStorage.setItem("language", lang);
        }
      };

      createVisit();
    }

    if (token) {
      const user = jwtDecode<ITokenPayload>(token);
      user && setUser(user);
    }
  }, [i18n.language]);

  const handleSwitchLanguage = (value: boolean) => {
    const lang = value ? CountryLanguage.EN : CountryLanguage.VI;
    changeLanguage(lang);
  };

  const handleSwitchLanguageWorld = (lang: CountryLanguage) => {
    localStorage.setItem("language", lang);

    changeLanguage(lang);
  };

  const handleCloseSidebar = () => {
    setIsClosing(true);

    setTimeout(() => {
      setOpenSidebar(false);
      setIsClosing(false);
    }, 250); // khớp với animation
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.google) {
        const headerEl = document.getElementById("googleSignInDiv");
        const sidebarEl = document.getElementById("googleSignInDivSidebar");

        window.google.accounts.id.initialize({
          client_id: envConfig.CLIENT_ID_GOOGLE,
          callback: handleGoogleLogin,
        });

        if (headerEl) {
          headerEl.innerHTML = "";
          window.google.accounts.id.renderButton(headerEl, {
            theme: "outline",
            size: "medium",
          });
        }

        if (sidebarEl) {
          sidebarEl.innerHTML = "";
          window.google.accounts.id.renderButton(sidebarEl, {
            theme: "outline",
            size: "medium",
          });
        }

        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [openSidebar, user]);

  const handleGoogleLogin = async (res: any) => {
    const rq: IGoogleLoginRequest = {
      credential: res.credential,
    };

    const resLogin = await AuthService.loginWithGoogleMail(rq);
    if (resLogin.success) {
      localStorage.setItem("token", resLogin.data.token);
      setData("loginSuccess");
      const decoded = parseJwt(res.credential);

      setUser({
        fullName: decoded.name,
        email: decoded.email,
        avatar: decoded.picture,
        userId: "",
        createdAt: "",
        isAdmin: decoded.isAdmin,
      });

      toast(t("auth.loginSuccess"), "success");
    } else {
      toast(t("auth.loginFailed"), "error");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setUser(null);
    setShowMenu(false);
    setData("loginOut");
  };

  function RenderHead({ html }: { html: string }) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const elements: ReactNode[] = [];

    doc.head.childNodes.forEach((node, index) => {
      if (node.nodeName === "SCRIPT") {
        const script = node as HTMLScriptElement;

        elements.push(
          <script
            key={index}
            {...Array.from(script.attributes).reduce((acc, attr) => {
              acc[attr.name] = attr.value;
              return acc;
            }, {} as any)}
            dangerouslySetInnerHTML={{ __html: script.innerHTML }}
          />,
        );
      }

      if (node.nodeName === "META") {
        const meta = node as HTMLMetaElement;

        elements.push(
          <meta
            key={index}
            {...Array.from(meta.attributes).reduce((acc, attr) => {
              acc[attr.name] = attr.value;
              return acc;
            }, {} as any)}
          />,
        );
      }

      if (node.nodeName === "LINK") {
        const link = node as HTMLLinkElement;

        elements.push(
          <link
            key={index}
            {...Array.from(link.attributes).reduce((acc, attr) => {
              acc[attr.name] = attr.value;
              return acc;
            }, {} as any)}
          />,
        );
      }

      if (node.nodeName === "NOSCRIPT") {
        elements.push(
          <noscript
            key={index}
            dangerouslySetInnerHTML={{
              __html: (node as HTMLElement).innerHTML,
            }}
          />,
        );
      }
    });

    return <Helmet>{elements}</Helmet>; // ✅ QUAN TRỌNG
  }

  return (
    <>
      {console.log("paypal", envConfig.CLIENT_ID_PAYPAL)}
      <HelmetProvider>
        <PayPalScriptProvider
          options={{
            clientId: envConfig.CLIENT_ID_PAYPAL,
            currency: "USD",
          }}>
          <Helmet>
            {/* ===== BASIC SEO ===== */}
            {/* <title>{setting?.title || "Dịch tài liệu online | MikoTech"}</title> */}

            {/* <meta
            name="description"
            content={
              setting?.slogan ||
              "Dịch tài liệu online nhanh, chính xác, bảo mật. Hỗ trợ PDF, Word, Excel, PPT, hình ảnh."
            }
          /> */}

            {/* <meta
            name="keywords"
            content={"dịch tài liệu, dịch file pdf, dịch tiếng anh"}
          /> */}

            <link rel="icon" href="/logo/Logo-D-docme.vn-2026.png" />
            <meta name="author" content="MikoTech" />
            {/* <meta
            name="robots"
            content={setting?.noIndex ? "noindex, nofollow" : "index, follow"}
          /> */}
            {/* ===== CANONICAL ===== */}
            {/* <link
            rel="canonical"
            href={setting?.website || "https://dichtailieu.mikotech.vn"}
          /> */}

            {/* ===== OPEN GRAPH ===== */}
            {/* <meta property="og:type" content="website" />
          <meta property="og:site_name" content="MikoTech" />
          <meta property="og:title" content={setting?.title} />
          <meta property="og:description" content={setting?.slogan} />
          <meta
            property="og:url"
            content={setting?.website || "https://dichtailieu.mikotech.vn"}
          />
          <meta
            property="og:image"
            content={"https://dichtailieu.mikotech.vn/seo/preview.png"}
          />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:locale" content="vi_VN" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={setting?.title} />
          <meta name="twitter:description" content={setting?.slogan} />
          <meta
            name="twitter:image"
            content={"https://dichtailieu.mikotech.vn/seo/preview.png"}
          /> */}

            {/* ===== CONTACT / BUSINESS INFO ===== */}
            {/* {setting?.email && <meta name="email" content={setting.email} />}
            {setting?.hotline && (
              <meta name="telephone" content={setting.hotline} />
            )}
            {setting?.address && (
              <meta name="address" content={setting.address} />
            )} */}

            {/* ===== GOOGLE ANALYTICS ===== */}
            {/* {setting?.googleAnalytics && (
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html: setting.googleAnalytics,
                }}
              />
            )} */}

            {/* ===== HEAD JS (ADMIN CUSTOM) ===== */}
            {/* {setting?.headJs && (
              <div
                dangerouslySetInnerHTML={{
                  __html: setting.headJs,
                }}
              />
            )} */}
          </Helmet>
          <style>{DOCME_FOOTER_CSS}</style>
          {/* {setting?.googleAnalytics && (
            <RenderHead html={setting.googleAnalytics} />
          )}
          {setting?.googleWebmaster && (
            <RenderHead html={setting.googleWebmaster} />
          )}
          {setting?.headScriptJs && <RenderHead html={setting.headScriptJs} />} */}
          {/* ===== BODY / FANPAGE JS ===== */}
          {/* {setting?.bodyJs && (
            <div dangerouslySetInnerHTML={{ __html: setting.bodyJs }} />
          )} */}
          {/* {setting?.fanpageJs && (
            <div dangerouslySetInnerHTML={{ __html: setting.fanpageJs }} />
          )}
          {setting?.schema && (
            <div dangerouslySetInnerHTML={{ __html: setting.schema }} />
          )} */}
          <Page>
            <Header>
              <HeaderContainer>
                <Logo>
                  <a href="./">
                    {envConfig.KEY_BASE === "vn" ? (
                      <img
                        style={{ display: "flex", gap: "8px", width: 140 }}
                        src="/logo/Untitled-1.svg"
                      />
                    ) : (
                      <img
                        style={{ display: "flex", gap: "8px", width: 140 }}
                        src="/logo/Logo-docme.world-2026.png"
                      />
                    )}

                    {/* <LogoIcon  /> */}
                    {/* <h1 style={{ margin: 0, fontSize: "1.25rem" }}>AI Tools</h1> */}
                  </a>
                </Logo>

                {/* MENU */}
                <NavMenu>
                  {isActive("/") ? (
                    <NavItemActive onClick={() => navigate("/")}>
                      {t("menu.home")}
                    </NavItemActive>
                  ) : (
                    <NavItem onClick={() => navigate("/")}>
                      {" "}
                      {t("menu.home")}
                    </NavItem>
                  )}

                  {envConfig.KEY_BASE === "vn" &&
                    (isActive("/blog") ? (
                      <NavItemActive onClick={() => navigate("/blog")}>
                        {t("menu.blog")}
                      </NavItemActive>
                    ) : (
                      <NavItem onClick={() => navigate("/blog")}>
                        {" "}
                        {t("menu.blog")}
                      </NavItem>
                    ))}

                  {isActive("/faq") ? (
                    <NavItemActive onClick={() => navigate("/faq")}>
                      {t("menu.faq")}
                    </NavItemActive>
                  ) : (
                    <NavItem onClick={() => navigate("/faq")}>
                      {" "}
                      {t("menu.faq")}
                    </NavItem>
                  )}

                  {/* <NavItem onClick={() => navigate("/translate")}>
                  Dịch tài liệu
                </NavItem> */}

                  {/* <NavItem onClick={() => navigate("/pricing")}>Bảng giá</NavItem> */}
                </NavMenu>

                <MobileMenuButton onClick={() => setOpenSidebar(true)}>
                  ☰
                </MobileMenuButton>

                <AuthBox>
                  <NotificationCenter />
                  {envConfig.KEY_BASE === "world" ? (
                    <>
                      <Box display="flex" alignItems="center" gap={1}>
                        <FormControl size="small">
                          <Select
                            value={i18n.language}
                            onChange={(e) =>
                              handleSwitchLanguageWorld(
                                e.target.value as CountryLanguage,
                              )
                            }
                            sx={{
                              minWidth: 120,
                              height: 36,
                              borderRadius: "10px",
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },

                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },

                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: "none",
                                },
                            }}>
                            <MenuItem
                              value={CountryLanguage.EN}
                              sx={{ gap: "5px" }}>
                              <img
                                width={20}
                                src="/flag/330px-Flag_of_the_United_States.svg.png"
                              />{" "}
                              English
                            </MenuItem>

                            <MenuItem
                              value={CountryLanguage.ID}
                              sx={{ gap: "5px" }}>
                              <img
                                width={20}
                                src="/flag/330px-Flag_of_Indonesia.svg.png"
                              />{" "}
                              Indonesia
                            </MenuItem>

                            <MenuItem
                              value={CountryLanguage.TH}
                              sx={{ gap: "5px" }}>
                              <img
                                width={20}
                                src="/flag/330px-Flag_of_Thailand.svg.webp"
                              />{" "}
                              ไทย
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography
                          variant="body2"
                          color={
                            !checked
                              ? "linear-gradient(135deg, rgb(243, 231, 255) 0%, rgb(255, 255, 255) 50%, rgb(224, 242, 255) 100%)"
                              : "text.secondary"
                          }
                          sx={{ fontWeight: !checked ? "bold" : "normal" }}>
                          VI
                        </Typography>

                        <LanguageSwitch
                          checked={checked}
                          onChange={(e) =>
                            handleSwitchLanguage(e.target.checked)
                          }
                        />

                        <Typography
                          variant="body2"
                          color={
                            checked
                              ? "linear-gradient(135deg, rgb(243, 231, 255) 0%, rgb(255, 255, 255) 50%, rgb(224, 242, 255) 100%)"
                              : "text.secondary"
                          }
                          sx={{
                            fontWeight: checked ? "bold" : "normal",
                          }}>
                          EN
                        </Typography>
                      </Box>
                    </>
                  )}

                  {!user ? (
                    <GoogleButton id="googleSignInDiv" />
                  ) : (
                    <>
                      <UserMenuWrapper>
                        <UserTrigger onClick={() => setShowMenu((v) => !v)}>
                          <Avatar src={user.avatar} />
                          <UserName>{user.fullName}</UserName>
                        </UserTrigger>

                        {showMenu && (
                          <DropdownMenu>
                            <DropdownItem>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-person"
                                viewBox="0 0 16 16">
                                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                              </svg>
                              {user.email}
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                navigate("/transaction-histories")
                              }>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                fill="currentColor"
                                className="bi bi-hourglass"
                                viewBox="0 0 16 16">
                                <path d="M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5m2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702c0 .7-.478 1.235-1.011 1.491A3.5 3.5 0 0 0 4.5 13v1h7v-1a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351v-.702c0-.7.478-1.235 1.011-1.491A3.5 3.5 0 0 0 11.5 3V2z" />
                              </svg>
                              {t("user.transactionHistory")}
                            </DropdownItem>
                            <DropdownItemLogout onClick={handleLogout}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-box-arrow-right"
                                viewBox="0 0 16 16">
                                <path
                                  fillRule="evenodd"
                                  d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
                                />
                                <path
                                  fillRule="evenodd"
                                  d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                                />
                              </svg>
                              {t("user.logout")}
                            </DropdownItemLogout>
                          </DropdownMenu>
                        )}
                      </UserMenuWrapper>
                    </>
                  )}
                </AuthBox>
                {/* <LoginButton>Đăng nhập</LoginButton> */}
              </HeaderContainer>

              {openSidebar && (
                <>
                  <Overlay onClick={handleCloseSidebar} />

                  <Sidebar isClosing={isClosing}>
                    {user && (
                      <>
                        <SidebarUserMobile>
                          <UserTrigger onClick={() => setShowMenu((v) => !v)}>
                            <Avatar src={user.avatar} />
                          </UserTrigger>

                          <LogoutIcon onClick={handleLogout}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-box-arrow-right"
                              viewBox="0 0 16 16">
                              <path
                                fillRule="evenodd"
                                d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
                              />
                              <path
                                fillRule="evenodd"
                                d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                              />
                            </svg>
                          </LogoutIcon>
                        </SidebarUserMobile>
                      </>
                    )}

                    <SidebarItemMain>
                      <SidebarItem
                        onClick={() => {
                          navigate("/");
                          setOpenSidebar(false);
                        }}>
                        {t("menu.home")}
                      </SidebarItem>

                      {envConfig.KEY_BASE === "vn" && (
                        <SidebarItem
                          onClick={() => {
                            navigate("/blog");
                            setOpenSidebar(false);
                          }}>
                          {t("menu.blog")}
                        </SidebarItem>
                      )}

                      <SidebarItem
                        onClick={() => {
                          navigate("/faq");
                          setOpenSidebar(false);
                        }}>
                        {t("menu.faq")}
                      </SidebarItem>

                      {user && (
                        <SidebarItem
                          onClick={() => navigate("/transaction-histories")}>
                          {t("user.transactionHistory")}
                        </SidebarItem>
                      )}

                      {envConfig.KEY_BASE === "world" ? (
                        <>
                          <Box
                            paddingTop={"1rem"}
                            display="flex"
                            alignItems="center"
                            gap={1}>
                            <FormControl fullWidth size="small">
                              <Select
                                value={i18n.language}
                                onChange={(e) =>
                                  handleSwitchLanguageWorld(
                                    e.target.value as CountryLanguage,
                                  )
                                }
                                sx={{
                                  minWidth: 120,
                                  height: 36,
                                  borderRadius: "10px",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },

                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },

                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none",
                                    },
                                }}>
                                <MenuItem
                                  value={CountryLanguage.EN}
                                  sx={{ gap: "5px" }}>
                                  <img
                                    width={20}
                                    src="/flag/330px-Flag_of_the_United_States.svg.png"
                                  />{" "}
                                  English
                                </MenuItem>

                                <MenuItem
                                  value={CountryLanguage.ID}
                                  sx={{ gap: "5px" }}>
                                  <img
                                    width={20}
                                    src="/flag/330px-Flag_of_Indonesia.svg.png"
                                  />{" "}
                                  Indonesia
                                </MenuItem>

                                <MenuItem
                                  value={CountryLanguage.TH}
                                  sx={{ gap: "5px" }}>
                                  <img
                                    width={20}
                                    src="/flag/330px-Flag_of_Thailand.svg.webp"
                                  />{" "}
                                  ไทย
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </>
                      ) : (
                        <>
                          <Box
                            paddingTop={"1rem"}
                            display="flex"
                            alignItems="center"
                            gap={1}>
                            <Typography
                              variant="body2"
                              color={
                                !checked
                                  ? "linear-gradient(135deg, rgb(243, 231, 255) 0%, rgb(255, 255, 255) 50%, rgb(224, 242, 255) 100%)"
                                  : "text.secondary"
                              }
                              sx={{ fontWeight: !checked ? "bold" : "normal" }}>
                              VI
                            </Typography>

                            <LanguageSwitch
                              checked={checked}
                              onChange={(e) =>
                                handleSwitchLanguage(e.target.checked)
                              }
                            />

                            <Typography
                              variant="body2"
                              color={
                                checked
                                  ? "linear-gradient(135deg, rgb(243, 231, 255) 0%, rgb(255, 255, 255) 50%, rgb(224, 242, 255) 100%)"
                                  : "text.secondary"
                              }
                              sx={{
                                fontWeight: checked ? "bold" : "normal",
                              }}>
                              EN
                            </Typography>
                          </Box>
                        </>
                      )}

                      {!user ? (
                        <div style={{ paddingTop: "1rem" }}>
                          <GoogleButton id="googleSignInDivSidebar" />
                        </div>
                      ) : (
                        <></>
                        // <>
                        //   <SidebarItem>{user.email}</SidebarItem>

                        //   <SidebarItem onClick={handleLogout}>
                        //     {t("user.logout")}
                        //   </SidebarItem>
                        // </>
                      )}
                    </SidebarItemMain>
                  </Sidebar>
                </>
              )}
            </Header>

            <main
              style={{
                maxWidth: 1280,
                margin: "0 auto",
                padding: "0 1rem",
              }}>
              <Outlet />
            </main>
            <ToastContainer />

            <Footer className="docme-footer">
              <FooterContainer className="docme-footer-inner">
                <div className="docme-footer-main">
                  <div className="docme-footer-card docme-footer-brand">
                    {envConfig.KEY_BASE === "vn" ? (
                      <a href="https://docme.vn/">
                        <img
                          src="data:image/png;base64,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"
                          width="150"
                          height="85"
                        />
                      </a>
                    ) : (
                      <a href="https://docme.world/">
                        <img
                          src="/logo/Logo-docme.world-2026.png"
                          width="150"
                          height="85"
                        />
                      </a>
                    )}

                    <p className="docme-footer-desc">
                      {t("footer.description")}
                    </p>

                    <div className="docme-footer-badge">
                      {t("footer.badge")}
                    </div>
                  </div>

                  <div className="docme-footer-card">
                    <h3 className="docme-footer-title">
                      {t("footer.contactTitle")}
                    </h3>

                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        footerAddress,
                      )}`}
                      target="_blank"
                      rel="noreferrer"
                      className="docme-footer-contact-item">
                      <FooterSvgIcon type="location" />
                      <span>{footerAddress}</span>
                    </a>

                    <a
                      href={`tel:${footerHotline}`}
                      className="docme-footer-contact-item">
                      <FooterSvgIcon type="phone" />
                      <span>{footerHotline}</span>
                    </a>

                    <a
                      href={`mailto:${footerEmail}`}
                      className="docme-footer-contact-item">
                      <FooterSvgIcon type="mail" />
                      <span>{footerEmail}</span>
                    </a>

                    <a
                      href={footerWebsite}
                      target="_blank"
                      rel="noreferrer"
                      className="docme-footer-contact-item">
                      <FooterSvgIcon type="globe" />
                      <span>{footerWebsite}</span>
                    </a>
                  </div>

                  <div className="docme-footer-card">
                    <h3 className="docme-footer-title">
                      {t("footer.supportTitle")}
                    </h3>

                    <ul className="docme-footer-links">
                      {footerSupportLinks?.map((item) => (
                        <li key={item.slug}>
                          <a href={envConfig.CLIENT_ENDPOINT + "/" + item.slug}>
                            {item.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="docme-footer-bottom">
                  <p>{t("footer.copyright")}</p>

                  <div className="docme-footer-bottom-links">
                    <a href="https://docme.vn/chinh-sach-dieu-khoan-su-dung">
                      {t("footer.terms")}
                    </a>
                    <span>/</span>
                    <a href="https://docme.vn/chinh-sach-bao-mat">
                      {t("footer.privacy")}
                    </a>
                  </div>
                </div>
              </FooterContainer>
            </Footer>

            {/* <div
              className="docme-bottom-marquee"
              role="status"
              aria-label={t("bottomMarquee.text")}>
              <div className="docme-bottom-marquee-track">
                <div className="docme-bottom-marquee-content">
                  <span className="docme-bottom-marquee-item">
                    <span className="docme-bottom-marquee-dot" />
                    <Trans i18nKey="bottomMarquee.text" />
                  </span>

                  <span className="docme-bottom-marquee-item">
                    <span className="docme-bottom-marquee-dot" />
                    <Trans i18nKey="bottomMarquee.text" />
                  </span>
                </div>

                <div
                  className="docme-bottom-marquee-content"
                  aria-hidden="true">
                  <span className="docme-bottom-marquee-item">
                    <span className="docme-bottom-marquee-dot" />
                    <Trans i18nKey="bottomMarquee.text" />
                  </span>

                  <span className="docme-bottom-marquee-item">
                    <span className="docme-bottom-marquee-dot" />
                    <Trans i18nKey="bottomMarquee.text" />
                  </span>
                </div>
              </div>
            </div> */}
          </Page>
        </PayPalScriptProvider>
      </HelmetProvider>
    </>
  );
}

export default App;
